<template>
  <div class="promo-code">
    <div class="promo-code__wrap" :class="{ error: isError }">
      <div class="promo-code__icon">
        <Icon name="/Premium/coupon.svg" />
      </div>
      <div class="promo-code__input" :class="{ disabled: disabled }">
        <input
          type="text"
          :value="value"
          :placeholder="$t('premium.enterPromocode')"
          :class="{ success: isSuccess }"
          @input="onInput"
        />
        <Button
          v-if="isSuccess"
          class="promo-code__button"
          type="secondary"
          :disabled="!value"
          @click="$emit('remove')"
        >
          {{ $t('actions.remove') }}
        </Button>
        <Button v-else class="promo-code__button" :disabled="!value" @click="$emit('apply')">
          {{ $t('actions.apply') }}
        </Button>
      </div>
    </div>
    <p class="promo-code__hint">
      <span v-if="isSuccess">
        {{ $t('actions.promocode.min') }}: {{ promoInfo.min_amount }}R$ {{ $t('actions.promocode.max') }}:
        {{ promoInfo.max_amount }}R$
      </span>
      <span class="status" :class="{ error: status === 'error', success: isSuccess }">
        {{ isSuccess ? $t('actions.promocode.success') : isError ? error : $t('actions.promocode.default') }}
      </span>
    </p>
  </div>
</template>

<script>
import Icon from '@/components/Base/Icon/Icon.vue'
import Button from '@/components/Base/Button/Button.vue'

export default {
  name: 'PromoCodeInput',
  components: { Button, Icon },
  props: {
    value: {
      value: String,
      default: ''
    },
    status: {
      value: String,
      default: ''
    },
    error: {
      value: String,
      default: ''
    },
    disabled: {
      value: Boolean,
      default: false
    }
  },
  computed: {
    isSuccess() {
      return this.status === 'success'
    },
    isError() {
      return this.status === 'error'
    },
    promoInfo() {
      return this.$store.state.promoCode.info || {}
    }
  },
  methods: {
    onInput(e) {
      const input = e.target
      const cursorPosition = input.selectionStart

      const oldValue = this.value
      const newValue = input.value

      // Преобразуем только если есть реальные изменения
      if (newValue.toUpperCase() !== oldValue) {
        const upperValue = newValue.toUpperCase()
        this.$emit('input', upperValue)

        // Восстанавливаем курсор
        this.$nextTick(() => {
          if (input && document.body.contains(input)) {
            input.setSelectionRange(cursorPosition, cursorPosition)
          }
        })
      }
    }
  }
}
</script>
<style lang="scss">
@import './PromoCodeInput.scss';
</style>
